import { getTHDCookie } from '../util/PrivacyCookieUtil';

export function reportGpcSignal(body)  {
    const endpoint = '/customer/gpc/v1/preference';
    return fetch(endpoint, {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(body)
    });
}

export function updatePrivacyOptOut(body) {
    const endpoint = `/cdg/epc/v3/customer/${body.svocId}/user/${body.userId}/privacy-opt-out`;
    return fetch(endpoint, {
        method: 'PUT',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'x-client-id': 'EPC-WEB'
        },
        credentials: 'omit',
        body: JSON.stringify({ isOptedOut: body.optOut })
    });
}

export function getPrivacyOptOut(svocId, userId) {
    const endpoint = `/cdg/epc/v3/customer/${svocId}/user/${userId}/privacy-opt-out`;
    return fetch(endpoint, {
    method: 'GET',
    headers: {
        'Accept': 'application/json'
    },
    credentials: 'omit',
    });
}
